import { useContext, useState } from "react";
import IdCell from "layouts/library/quote-list/components/IdCell";
import DefaultCell from "layouts/library/quote-list/components/DefaultCell";

import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { DataContext } from "context/dataContext";
import SnackbarAlert from "components/SnackbarAlert";
import DeleteConfirmationPopover from "components/DeleteConfirmationPopover";

const dataTableData = {
  columns: [
    {
      Header: "ID",
      accessor: "id",
      width: 100,
      linkByID: true,
      Cell: ({ value }) => <IdCell id={value} />,
    },
    {
      Header: "Quote",
      accessor: "quote",
      linkByID: true,
      Cell: ({ value }) => <MDBox sx={{ width: "200px", fontSize: "12px" }}>{value}</MDBox>,
    },
    {
      Header: "Author",
      accessor: "author",
      linkByID: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Actions",
      accessor: "actions",
      width: 10,
      align: "right",
      Cell: ({ row }) => {
        const { deleteSingleQuoteApi } = useContext(DataContext);

        return (
          <>
            <MDBox display="flex" gap={2}>
              <MDButton
                size="small"
                variant="gradient"
                color="primary"
                component={NavLink}
                to={`/library/edit-quote/${row.original.id}`}
              >
                Edit
              </MDButton>
              <DeleteConfirmationPopover
                heading="are you sure?"
                buttonText="Delete"
                DeleteFunction={() => {
                  deleteSingleQuoteApi(row.original.id);
                }}
              />
            </MDBox>
          </>
        );
      },
    },
  ],

  rows: [],
};

export default dataTableData;
